import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "password-forgot-form__title" }, [
  /*#__PURE__*/_createTextVNode(" Set your "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" new password ")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "password-forgot-form__description" }, [
  /*#__PURE__*/_createTextVNode(" You have requested to reset your password. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Please fill in the form below to proceed. ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Back to login")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_form_item = _resolveComponent("form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_form_element = _resolveComponent("form-element")!
  const _component_base_form = _resolveComponent("base-form")!

  return (_openBlock(), _createBlock(_component_base_form, { class: "password-forgot-form" }, {
    header: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    default: _withCtx(() => [
      _createVNode(_component_form_element, _mergeProps({ errors: _ctx.errors, model: _ctx.model, loading: _ctx.loading }, { onSubmit: _ctx.onSubmit }), {
        buttons: _withCtx(() => [
          _createVNode(_component_router_link, {
            to: { name: 'login' },
            class: "link"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_base_button, _mergeProps({
            secondary: "",
            type: "submit"
          }, { loading: _ctx.loading }), {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          }, 16)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_form_item, {
            label: "E-mail",
            name: 'email',
            rules: [_ctx.required, _ctx.email]
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.email) = $event)),
                class: "password-forgot-form__input",
                name: "email",
                type: "email",
                autocomplete: "login-email"
              }, null, 512), [
                [_vModelText, _ctx.model.email]
              ])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_form_item, {
            label: "New password",
            name: 'password',
            rules: [_ctx.required, _ctx.minLength(8)]
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.password) = $event)),
                class: "password-forgot-form__input",
                name: "password",
                type: "password",
                autocomplete: "none"
              }, null, 512), [
                [_vModelText, _ctx.model.password]
              ])
            ]),
            _: 1
          }, 8, ["rules"]),
          _createVNode(_component_form_item, {
            label: "Confirm password",
            name: 'password_confirmation',
            rules: [_ctx.required, _ctx.same(() => _ctx.model.password)]
          }, {
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.password_confirmation) = $event)),
                class: "password-forgot-form__input",
                name: "password_confirmation",
                type: "password",
                autocomplete: "none"
              }, null, 512), [
                [_vModelText, _ctx.model.password_confirmation]
              ])
            ]),
            _: 1
          }, 8, ["rules"])
        ]),
        _: 1
      }, 16, ["onSubmit"])
    ]),
    _: 1
  }))
}